import { memo, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { useMsal } from "@azure/msal-react";
import { useAppContext } from "../../Context/AppContext";

const SessionExpiredModal = memo(function SessionExpiredModal() {
  const { instance } = useMsal();
  const { sessionExpired, setSessionExpired } = useAppContext();

  const handleClose = useCallback(() => {
    setSessionExpired(false);
  }, [setSessionExpired]);

  const handleLoginAgain = useCallback(async () => {
    try {
      await instance.logoutRedirect();
    } catch (error) {
      console.error("Logout failed:", error);
    }
  }, [instance]);

  return (
    <Modal show={sessionExpired} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Session Expired</Modal.Title>
      </Modal.Header>
      <Modal.Body>Your session has expired. Please login again to continue.</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleLoginAgain}>
          Login Again
        </Button>
      </Modal.Footer>
    </Modal>
  );
});

SessionExpiredModal.displayName = "SessionExpiredModal";

export default SessionExpiredModal;
